import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var Badge = styled.span.withConfig({
  displayName: "Badgestyles__Badge",
  componentId: "keen-query-creator__sc-3bycjy-0"
})(["&&&{padding:3px;font-size:12px;line-height:14px;font-family:'Lato Bold',sans-serif;border-radius:2px;background:", ";color:", ";}"], colors.blue[100], colors.white[500]);